import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../../assets/kangaroo/logo.png";
import "../../../Homepage/Component/Homepage.css";
import { motion, AnimatePresence } from "framer-motion";
import {
  ChevronDown,
  ChevronUp,
  CornerDownRight,
  MoveRight,
  X,
} from "lucide-react";
import arrow from "../../../assets/kangaroo/arrow-cropped.svg";
import Destinationcountry from "../../../services/Destinationcountry";
import generalService from "../../../services/generalPage";
import { imageBaseApi } from "../../../services/imageBaseApi";
import ProfileDropdown from "../../../common/ProfileDropdown";

const Navbar = ({ headerMenus }) => {
  const router = useNavigate();
  const location = useLocation();
  const isTransparent = location.pathname === "/";
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(null);
  const [openDropdown, setOpenDropdown] = useState({});
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;
  const toggleDropdown = (key) => {
    setOpenDropdown((prev) => ({
      ...prev,
      [key]: !prev[key], // toggle the specific dropdown
    }));
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const closeMenuLogout = () => {
    setIsMenuOpen(false);
    localStorage.removeItem("user");
    // optional extras
    // localStorage.clear(); // clears EVERYTHING (use carefully)
    window.location.href = "/login";
  };

  const fetchCountryData = async () => {
    try {
      const response = await Destinationcountry.getList();

      return response;
    } catch (error) {
      console.error("Error fetching country data:", error);
      return null;
    }
  };

  //  const { isLoading, error, data: menuData } = useQuery({
  //   queryKey: ['countryData'],
  //   queryFn: () => fetchCountryData(),
  // })

  // const mobileMenuItems = [
  //   {
  //     name: "STUDY ABROAD",
  //     key: "StudyAbroad",
  //     children: [
  //       ...(menuData?.map((country) => ({
  //         name: country.name,
  //         path: `/innerpage/${country?.id}`,
  //       })) || []), // spread the mapped array, fallback to empty array
  //       { name: "Institution We Represent", path: "/institutionrepresent" }, // static item
  //     ],
  //   },
  //   {
  //     name: "TEST PREPARATION",
  //     key: "TestPreparation",
  //     path: "/testpreparation",
  //     children: [
  //       { name: "IELTS", path: "/testprep/ielts" },
  //       { name: "PTE", path: "/testprep/ielts" },
  //       { name: "Duolingo", path: "/testprep/ielts" },
  //       { name: "TOEFL", path: "/testprep/ielts" },
  //       { name: "GRE", path: "/testprep/ielts" },
  //       { name: "GMAT", path: "/testprep/ielts" },
  //     ],
  //   },
  //   {
  //     name: "RESOURCES",
  //     key: "Resources",
  //     children: [
  //       { name: "Study Abroad Facts", path: "/resources/abroadFact" },
  //       { name: "Sample Documents", path: "/resources/document" },
  //       { name: "Statement of Purpose", path: "/resources/sop" },
  //       { name: "Interview Preparation Guidelines", path: "/testpreparation" },
  //     ],
  //   },
  //   {
  //     name: "ABOUT",
  //     key: "About",
  //     children: [
  //       { name: "Who We Are", path: "/about/whoweare" },
  //       { name: "Milestone", path: "/about/milestone" },
  //       { name: "Partnership", path: "/about/partner" },
  //       { name: "CEO", path: "/about/aboutceo" },
  //     ],
  //   },
  //   {
  //     name: "CORPORATE",
  //     key: "Corporate",
  //     children: [
  //       { name: "Career", path: "/corporate/career" },
  //       { name: "Become Our Franchise", path: "/corporate/franchise" },
  //       { name: "Download Company Profile", path: null, isAction: true },
  //       { name: "KEF Intelligence", path: "/" },
  //       { name: "Smart Kampus", path: "/" },
  //       { name: "DMS", path: "/" },
  //       { name: "Brand Identity Guidelines", path: "/" },
  //     ],
  //   },
  //   { name: "BLOG", key: "Blog", path: "/blog" },
  //   { name: "EVENTS", key: "Events", path: "/events" },
  //   { name: "CONTACT", key: "Contact", path: "/contact" },
  // ];

  // headerMenus?.forEach((menu, index) => {
  //   console.log(`MENU ${index}`, {
  //     isActive: menu.isActive,
  //     menuTypes: menu.menuTypes,
  //   });
  // });

  const menus = [
    {
      id: "static-2",
      title: "Home",
      url: "/",
      slug: "home",
      isActive: true,
      children: [],
    },
    {
      id: "static-3",
      title: "Brand.Identity.Guidelines",
      slug: "identity",
      isActive: true,
      url: "brand-identity-guideline",
      children: [
        {
          id: "static-3-1",
          title: "Brand",
          url: "/brand-identity-guideline/brand",
          slug: "brand",
          isActive: true,
        },
        {
          id: "static-3-2",
          title: "Identity",
          url: "/brand-identity-guideline/identity",
          slug: "identity",
          isActive: true,
        },
        {
          id: "static-3-3",
          title: "Guidelines",
          url: "/brand-identity-guideline/guideline",
          slug: "guideline",
          isActive: true,
        },
      ],
    },
    {
      id: "static-2",
      title: "Artworks & Assets",
      url: "/artwork",
      slug: "artworks-assets",
      isActive: true,
      children: [],
    },

  ];

  return (
    <nav
      className={`navbar navbar-expand-lg ${isTransparent ? "fixed-top" : "sticky-top"} `}
      style={{
        background: isScrolled ? "#812990" : (isTransparent ? "transparent" : "white"),
        backdropFilter: isScrolled ? "blur(8px)" : "none",
        boxShadow: isScrolled ? "0 4px 10px rgba(0, 0, 0, 0.1)" : (isTransparent ? "none" : "0 0.5px 0 #687c8694"),
        border: "none",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <div
        className="container-fluid px-0 py-1 "
        style={{ backgroundColor: "transparent", transition: "all 0.3s ease-in-out" }}
      >
        <div className="row w-100 align-items-center justify-content-end mx-0" style={{ paddingRight: "5rem" }}>
          {/* Logo Column */}
          {/* <div className="col-6 col-lg-2 px-0">
            <img
              src={logo}
              className="img-fluid"
              style={{
                maxHeight: "70px",
                height: "auto",
                width: "auto",
                cursor: "pointer",
              }}
              onClick={() => {
                router("/");
              }}
              alt="Logo"
            />
          </div> */}

          {/* Hamburger Menu Column - Visible on mobile/tablet */}
          <div className="col-auto custom-mobile px-0 ms-auto text-end">
            <button
              className="border-0 bg-transparent"
              onClick={toggleMenu}
              style={{
                fontSize: "1.5rem",
                cursor: "pointer",
                padding: "0.5rem",
                zIndex: 1001,
              }}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "2px",
                      background: isScrolled ? "white" : (isTransparent ? "white" : "#6c757d"),
                      transform: "rotate(45deg)",
                      top: "11px",
                    }}
                  ></div>
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "2px",
                      background: isScrolled ? "white" : (isTransparent ? "white" : "#6c757d"),
                      transform: "rotate(-45deg)",
                      top: "11px",
                    }}
                  ></div>
                </div>
              ) : (
                <div
                  style={{
                    width: "24px",
                    height: "18px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      background: isScrolled ? "white" : (isTransparent ? "white" : "#6c757d"),
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      background: isScrolled ? "white" : (isTransparent ? "white" : "#6c757d"),
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      background: "#6c757d",
                    }}
                  ></div>
                </div>
              )}
            </button>
          </div>

          {/* Desktop Menu Column - Hidden on mobile/tablet */}
          <div
            className="col-auto custom-desktop px-0 ms-auto"
            style={{ backgroundColor: "transparent" }}
          >
            <div className="row align-items-center justify-content-end mx-0 flex-nowrap">
              {menus?.map((menu) => (
                <div
                  key={menu.id}
                  className="col-auto px-xl-3 px-lg-2 px-1 h-25 py-2"
                  style={{ position: "relative" }}
                  onMouseEnter={() => setShowDropdown(menu.id)}
                  onMouseLeave={() => setShowDropdown(null)}
                >
                  {menu.url ? (
                    <Link
                      to={`${menu?.url || "#"}`}
                      className="navbar-item-font py-2"
                      style={{
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
                        color: isScrolled ? "white" : "black",
                      }}
                    >
                      {menu.title.toUpperCase()}
                    </Link>
                  ) : (
                    <span
                      className="navbar-item-font py-2"
                      style={{
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
                        cursor:
                          menu.children?.length > 0 ? "default" : "not-allowed",
                        color: isScrolled ? "white" : "black",
                      }}
                    >
                      {menu.title.toUpperCase()}
                    </span>
                  )}

                  {/* Dropdown */}
                  {menu.children?.length > 0 && showDropdown === menu.id && (
                    <div className="nav-dropdown mt-0">
                      {menu.children
                        .filter((child) => child.isActive)
                        .sort((a, b) => a.orderIndex - b.orderIndex)
                        .map((child, index, arr) => (
                          <React.Fragment key={child.id}>
                            {child.isPdf ? (
                              <a
                                className="nav-dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={async () => {
                                  try {
                                    const response =
                                      await generalService.getBySlug(
                                        child.slug,
                                      );
                                    const pdfUrl = response?.featuredMedia?.url;
                                    if (pdfUrl) {
                                      window.open(
                                        imageBaseApi + pdfUrl,
                                        "_blank",
                                      );
                                    } else {
                                      console.error("PDF URL not found");
                                    }
                                  } catch (error) {
                                    console.error("Error fetching PDF:", error);
                                  }
                                }}
                              >
                                {child.title}
                              </a>
                            ) : child.isExternal ? (
                              <a
                                href={child.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="nav-dropdown-item"
                              >
                                {child.title}
                              </a>
                            ) : child.url ? (
                              <Link
                                to={child.url}
                                className="nav-dropdown-item"
                              >
                                {child.title}
                              </Link>
                            ) : (
                              <span
                                className="nav-dropdown-item"
                                style={{ cursor: "not-allowed", opacity: 0.6 }}
                              >
                                {child.title}
                              </span>
                            )}

                            {index !== arr.length - 1 && (
                              <hr className="nav-hr mx-3" />
                            )}
                          </React.Fragment>
                        ))}
                    </div>
                  )}
                </div>
              ))}
              <div className="col-auto ps-xl-2 ps-lg-1 pe-0 d-flex align-items-center gap-2">
                <button
                  style={{
                    background: "linear-gradient(to right, #7e1790, #d70a84)",
                    color: "white",
                    border: "none",
                    borderRadius: "35px",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    paddingTop: "0.75rem",
                    paddingBottom: "0.75rem",
                    fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
                  }}
                  className="navbar-btn-font px-xl-3 px-lg-2 ms-xl-2"
                  onClick={closeMenuLogout}
                >
                  LOG OUT
                </button>

              </div>

              {/* <div className="col-auto ps-xl-2 ps-lg-1 pe-0 d-flex align-items-center gap-2">
                <button
                  style={{
                    background: "linear-gradient(to right, #7e1790, #d70a84)",
                    color: "white",
                    border: "none",
                    borderRadius: "35px",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    paddingTop: "0.75rem",
                    paddingBottom: "0.75rem",
                    fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
                  }}
                  className="navbar-btn-font px-xl-3 px-lg-2 ms-xl-2"
                  onClick={closeMenuLogout}
                >
                  LOG OUT
                </button>
                {token && (
                  <div className="d-flex align-items-center">
                    <ProfileDropdown />
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu - Slides in from right */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: isMenuOpen ? 0 : "-100%",
          width: "80%",
          maxWidth: "400px",
          height: "100vh",
          background: "white",
          boxShadow: isMenuOpen ? "-2px 0 10px rgba(0,0,0,0.1)" : "none",
          transition: "right 0.3s ease-in-out",
          zIndex: 999,
          overflowY: "auto",
          padding: "80px 2rem 2rem",
        }}
      >
        <div
          onClick={closeMenu}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            fontSize: "1.5rem",
            cursor: "pointer",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          <X />
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div>
                {menus?.map((item) => (
                  <div key={item.id} style={{ marginBottom: "1rem" }}>
                    {/* Main link */}
                    <div
                      onClick={() => {
                        if (item.children?.length > 0) {
                          // Menu has dropdown → toggle
                          toggleDropdown(item.id);
                        } else {
                          // Menu has no dropdown → navigate
                          closeMenu(); // close mobile menu
                          router(item.url || `/${item.slug}`); // navigate
                        }
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "1.1rem",
                        borderBottom: "1px solid #e0e0e0",
                        marginBottom: "10px",
                        padding: "0.5rem 0",
                        cursor: "pointer",
                      }}
                    >
                      <span>{item.title}</span>

                      {item.children?.length > 0 && (
                        <span
                          style={{
                            transition: "transform 0.3s ease",
                            transform: openDropdown[item.id]
                              ? "rotate(180deg)"
                              : "rotate(90deg)",
                          }}
                        >
                          <ChevronUp
                            stroke={
                              openDropdown[item.id] ? "#7E1790" : "#FF4D1D"
                            }
                          />
                        </span>
                      )}
                    </div>

                    {/* Dropdown */}
                    <AnimatePresence>
                      {openDropdown[item.id] && item.children?.length > 0 && (
                        <motion.div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.3 }}
                          style={{ overflow: "hidden", paddingLeft: "0.5rem" }}
                        >
                          {item.children
                            .filter((child) => child.isActive)
                            .sort((a, b) => a.orderIndex - b.orderIndex)
                            .map((child) => (
                              <div
                                key={child.id}
                                className="d-flex align-items-center gap-2 my-2"
                              >
                                <img
                                  src={arrow}
                                  style={{ width: "10%" }}
                                  alt=""
                                />

                                {/* PDF Handling */}
                                {child.isPdf ? (
                                  <span
                                    className="d-block text-muted py-1"
                                    style={{
                                      textDecoration: "none",
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      try {
                                        const response =
                                          await generalService.getBySlug(
                                            child.slug,
                                          );
                                        const pdfUrl =
                                          response?.featuredMedia?.url;
                                        if (pdfUrl) {
                                          window.open(
                                            imageBaseApi + pdfUrl,
                                            "_blank",
                                          );
                                          closeMenu(); // close mobile menu
                                        } else {
                                          console.error("PDF URL not found");
                                        }
                                      } catch (error) {
                                        console.error(
                                          "Error fetching PDF:",
                                          error,
                                        );
                                      }
                                    }}
                                  >
                                    {child.title}
                                  </span>
                                ) : child.isExternal ? (
                                  <a
                                    href={child.url}
                                    className="d-block text-muted py-1"
                                    style={{ textDecoration: "none" }}
                                    onClick={closeMenu}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {child.title}
                                  </a>
                                ) : (
                                  <Link
                                    to={child.url}
                                    className="d-block text-muted py-1"
                                    style={{ textDecoration: "none" }}
                                    onClick={closeMenu}
                                  >
                                    {child.title}
                                  </Link>
                                )}
                              </div>
                            ))}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ))}
              </div>
              <button
                style={{
                  background: "linear-gradient(90deg, #7e1790, #d70a84)",
                  color: "white",
                  border: "none",
                  padding: "12px 24px",
                  borderRadius: "35px",
                  cursor: "pointer",
                  fontSize: "1rem",
                  marginTop: "1rem",
                }}
                onClick={closeMenuLogout}
              >
                LOG OUT
              </button>
              {/* {token && (
                <div className="d-flex align-items-center">
                  <ProfileDropdown />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>

      {/* Overlay - Click to close menu */}
      {isMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 998,
          }}
          onClick={closeMenu}
        />
      )}
    </nav>
  );
};

export default Navbar;
